import React from 'react';
import ReactDOM from 'react-dom';
import messages from '../services/Messages';
import Disposable from '../mixins/Disposable';
import KeyboardNavigation from '../mixins/KeyboardNavigation';
import co from '../lib/Co';
import $ from 'jquery';
import Shortcut from '../components/Shortcut';
import Button from '../components/Button';
import styled from 'styled-components';

const DialogStyles = styled.div`

  position: fixed; 
  z-index: 1599; 
  left: 0px; 
  top: 0px; 
  padding: 0px; 
  margin: 0px; 
  width: 100%; 
  height: 100%;

.w2ui-lock{
  position: fixed; 
  z-index: 1599; 
  left: 0px; 
  top: 0px; 
  padding: 0px; 
  margin: 0px; 
  width: 100%; 
  height: 100%; 
  background-color: rgb(0, 0, 0, 0.4);
}

.w2ui-popup{
  position: fixed;
  z-index: 1600;
  overflow: hidden;
  padding: 0px;
  margin: 0px;
  border: 1px solid #777777;
  box-shadow: 0px 0px 25px #555555;
  opacity: 1;
  border-radius: 5px;
  background-color: #FFFFFF;
}

.w2ui-popup,
.w2ui-popup * {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
}

.w2ui-msg-title{
  position: absolute;
  overflow: hidden;
  left: 0px;
  right: 0px;
  top: 0px;
  text-overflow: ellipsis;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  cursor: move;
  font-size: 15px;
  color: #555555;
  background-color: #FFFFFF;
  height: 40px;
  border-bottom: 1px solid #c7c7c7;
  border-radius: 5px 5px 0 0;
  padding: 10px 6px;
  font-weight: bold;
}

.w2ui-msg-close {
  float: right;
  width: 18px;
  height: 18px;
  cursor: pointer;
  overflow: hidden;
  padding: 0px;
  margin: 2px 3px 0px 0px;
  background: url(data:image/png;base64,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) no-repeat center left;
  background-position: -32px 0px;
  color: transparent !important;
  border-radius: 3px;
  border: 1px solid transparent;
}
.w2ui-msg-close:hover {
  background-color: #cccccc;
  border: 1px solid #aaaaaa;
}

.w2ui-box1{
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 55px;
  top: 40px;
  height: calc(100% - 85px);
}

.w2ui-msg-body{
  line-height: 130%;
  color: #000000;
  position: absolute;
  overflow: auto;
  height: calc(100% - 5px);
  width: 100%;
  font-size: 0.8125rem;
  background-color: #FFFFFF;
  padding: 0.9375rem
}

.w2ui-msg-buttons{
  border-radius: 0px 0px 6px 6px;
  position: absolute;
  overflow: hidden;
  left: 0px;
  right: 0px;
  bottom: 0px;
  text-align: right;
  padding: 5px;
  height: 45px;
  background-color: #FFFFFF;
  border-top: 1px solid #c7c7c7;
}

.w2ui-centered {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  max-height: 100%;
  margin: 0px;
  padding: 0px 10px;
  text-align: center;
}
`;

const Dialog = Disposable(class extends React.Component {

  constructor(props, context) {
    super(props, context);
    Object.assign(this, KeyboardNavigation);
  }

  static defaultProps = {
    modal: true,
    width: 400,
    height: 400,
    popup: 'popup'
  }

  componentDidMount = () => {
    var self = this;
    this.props.using(messages.channel(self.props.popup + 'Dialog').action('__close__').subscribe(result => {
      let r = self.props.onClose(result);
      if (r instanceof Promise) {
        r.then((data) => {
          if (!data) {
            return;
          }
          var node = $(document.getElementById(result.popup))[0];
          ReactDOM.unmountComponentAtNode(node);
        });
      }
      else {
        co(function* () {
          if (r && r.next && r.throw) {
            r = yield r;
          }
          if (!r) {
            return;
          }
          var node = $(document.getElementById(result.popup))[0];
          ReactDOM.unmountComponentAtNode(node);
        });
      }
    }));

    var top = (($(window).height() - this.props.height) / 2);
    var left = (($(window).width() - this.props.width) / 2);
    this.setState({ top: top, left: left });
    var domNode = $(ReactDOM.findDOMNode(this));
    // domNode.velocity({opacity: [1,0]}, { duration: 250 });

    var focusedControl = domNode.find('.initial-focus');
    if (!focusedControl || !focusedControl.length) {
      focusedControl = domNode.find('button:visible,.select2-focusser:visible,input:not(.select2-input,.select2-offscreen):visible,textarea:visible,select:visible').first();
    }

    setTimeout(() => {
      focusedControl.focus();
    }, 0);
  }

  handleMouseDown = (evt) => {
    this.setState({
      dragging: { x: evt.clientX, y: evt.clientY }
    });
  }

  handleMouseUp = () => {
    this.setState({ dragging: null });
  }

  handleMouseMove = (evt) => {
    if (!this.state.dragging) {
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();
    //ADDED BY MAYANK
    var popuptop = window.scrollY + document.querySelector('#w2ui-popup').getBoundingClientRect().top
    var popupleft =  window.scrollY + document.querySelector('#w2ui-popup').getBoundingClientRect().left
    var x = popupleft + evt.clientX - this.state.dragging.x;
    var y = popuptop + evt.clientY - this.state.dragging.y;
    document.querySelector('#w2ui-popup').style.top = y+'px';
    document.querySelector('#w2ui-popup').style.left = x+'px';
    //ADDED BY MAYANK
    this.setState({
      top: y,
      left: x,
      dragging: { x: evt.clientX, y: evt.clientY }
    });
  }

  handleLocalKeyDown = (evt) => {
    if (this.props.onKeyDown) {
      this.props.onKeyDown(evt);
      if (evt.isDefaultPrevented() || evt.isPropagationStopped()) {
        return;
      }
    }
    this.handleDialogKeyDown(evt);
  }

  componentWillUnmount = () => {
    if (this.props.popup === 'popup') {
      this.props.terminate();
    }
  }

  render = () => {
    var closeFn = Dialog.handleResult({ popup: this.props.popup, Cancel: true, Close: true });
    var modalHandler = this.props.modal ? null : closeFn;

    var closeHandler;
    if (this.props.showClose) {
      closeHandler = <div className='w2ui-msg-button w2ui-msg-close' onClick={closeFn}></div>;
    }

    const popupStyle = {
      width: this.props.width,
      height: this.props.height,
    };

    if (this.state) {
      //ADDED BY MAYANK
      //  popupStyle.top = this.state.top;
      //  popupStyle.left = this.state.left;
      //ADDED BY MAYANK
    }

    return (
      // MAYANK ADDED
      <DialogStyles {...this.props} onKeyDown={this.handleLocalKeyDown} onMouseMove={this.handleMouseMove} onMouseUp={this.handleMouseUp} style={{alignItems:"center", justifyContent:"center", display:"flex"}}>
        <div onClick={modalHandler} className='w2ui-lock' />
        <div ref='popup' className='w2ui-popup' id='w2ui-popup' style={popupStyle}>
          <div className='w2ui-msg-title' onMouseDown={this.handleMouseDown}>{this.props.header}{closeHandler}</div>
          {this.props.children}
        </div>
      </DialogStyles>
    );
  }
});

Dialog.OKButton = (props) => <Shortcut shortcutKey='enter' preventDefault action={Dialog.handleResult({ popup: props.popup || 'popup', OK: true })}><Button style={{ minWidth: 125, marginLeft: 10 }} variant='primary' size='sm' onClick={Dialog.handleResult({ popup: props.popup || 'popup', OK: true })} disabled={props.saving} icon='fa-check'>OK</Button></Shortcut>;
Dialog.CancelButton = (props) => <Shortcut shortcutKey='escape' preventDefault action={Dialog.handleResult({ popup: props.popup || 'popup', Cancel: true })}><Button style={{ minWidth: 125, marginLeft: 10 }} variant='danger' size='sm' onClick={Dialog.handleResult({ popup: props.popup || 'popup', Cancel: true })} disabled={props.saving} icon='fa-times'>Cancel</Button></Shortcut>;
Dialog.SaveButton = (props) => <Shortcut shortcutKey='ctrl+s' preventDefault action={Dialog.handleResult({ popup: props.popup || 'popup', Save: true })}><Button style={{ minWidth: 125, marginLeft: 10 }} variant='success' size='sm' onClick={Dialog.handleResult({ popup: props.popup || 'popup', Save: true })} disabled={props.saving} icon='fa-save' ignoreFacilityReadOnly={props.ignoreFacilityReadOnly}>Save</Button></Shortcut>;
Dialog.YesButton = (props) => <Shortcut shortcutKey='enter' preventDefault action={Dialog.handleResult({ popup: props.popup || 'popup', Yes: true })}><Button style={{ minWidth: 125, marginLeft: 10 }} variant='primary' size='sm' onClick={Dialog.handleResult({ popup: props.popup || 'popup', Yes: true })} disabled={props.saving} icon='fa-thumbs-up'>Yes</Button></Shortcut>;
Dialog.NoButton = (props) => <Button style={{ minWidth: 125, marginLeft: 10 }} variant='secondary' size='sm' onClick={Dialog.handleResult({ popup: props.popup || 'popup', No: true })} disabled={props.saving} icon='fa-thumbs-down' >No</Button>;
Dialog.CloseButton = (props) => <Button style={{ minWidth: 125, marginLeft: 10 }} variant='danger' size='sm' onClick={Dialog.handleResult({ popup: props.popup || 'popup', Close: true })} disabled={props.saving} icon='fa-times'>Close</Button>;
Dialog.Button = (props) => <Button style={{ minWidth: 125, marginLeft: 10 }} variant={props.variant} size='sm' className={props.className} onClick={Dialog.handleResult({ popup: props.popup || 'popup', ...props.result })} disabled={props.saving} icon={props.icon}>{props.children}</Button>;

Dialog.SaveCancelButtons = (props) => {
  return (
    <Dialog.Buttons>
      {props.children}
      <Dialog.SaveButton saving={props.saving} popup={props.popup} ignoreFacilityReadOnly={props.ignoreFacilityReadOnly} />
      <Dialog.CancelButton saving={props.saving} popup={props.popup} />
    </Dialog.Buttons>
  );
};

Dialog.SaveCloseButtons = (props) => {
  return (
    <Dialog.Buttons>
      <Dialog.SaveButton saving={props.saving} popup={props.popup} />
      <Dialog.CloseButton popup={props.popup} />
    </Dialog.Buttons>
  );
};

Dialog.OKCancelButtons = (props) => {
  return (
    <Dialog.Buttons>
      <Dialog.OKButton popup={props.popup} />
      <Dialog.CancelButton popup={props.popup} />
    </Dialog.Buttons>
  );
};

Dialog.YesNoCancelButtons = (props) => {
  return (
    <Dialog.Buttons>
      <Dialog.YesButton popup={props.popup} />
      <Dialog.NoButton popup={props.popup} />
      <Dialog.CancelButton popup={props.popup} />
    </Dialog.Buttons>
  );
};

Dialog.YesNoButtons = (props) => {
  return (
    <Dialog.Buttons>
      <Dialog.YesButton popup={props.popup} />
      <Dialog.NoButton popup={props.popup} />
    </Dialog.Buttons>
  );
};

Dialog.OKButtons = (props) => {
  return (
    <Dialog.Buttons>
      <Dialog.OKButton popup={props.popup} />
    </Dialog.Buttons>
  );
};

Dialog.Body = (props) => {

  return (
    <div className='w2ui-box1'>
      <div className='w2ui-msg-body'>
        {props.children}
      </div>
    </div>
  );
}

Dialog.Buttons = (props) => {

  return (
    <div className='w2ui-msg-buttons'>
      {props.children}
    </div>
  );
}

Dialog.OKCancelDialog = (props) => {
  return (
    <Dialog {...props}>
      <div className='w2ui-centered'>
        {props.children}
      </div>
      <Dialog.OKCancelButtons popup={props.popup} />
    </Dialog>
  );
}

Dialog.YesNoCancelDialog = (props) => {
  return (
    <Dialog {...props}>
      <div className='w2ui-centered'>
        {props.children}
      </div>
      <Dialog.YesNoCancelButtons popup={props.popup} />
    </Dialog>
  );
}

Dialog.YesNoDialog = (props) => {
  return (
    <Dialog {...props}>
      <div className='w2ui-centered'>
        {props.children}
      </div>
      <Dialog.YesNoButtons popup={props.popup} />
    </Dialog>
  );
}


Dialog.OKDialog = (props) => {
  return (
    <Dialog {...props}>
      <div className='w2ui-centered'>
        {props.children}
      </div>
      <Dialog.Buttons>
        <Dialog.OKButton popup={props.popup} />
      </Dialog.Buttons>
    </Dialog>
  );
}


Dialog.handleResult = (result) => {
  return (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    messages.channel(result.popup + 'Dialog').action('__close__').post(result);
  };
};

Dialog.showDialog = (dialog, popup = 'popup') => {
  ReactDOM.render(dialog, document.getElementById(popup));
};

Dialog.showDialogWaitForResult = (dialog, popup = 'popup') => {
  return (cb) => {
    const dialogObj = { ...dialog };
    const dialogProps = {
      onClose: (result) => {
        cb(null, result);
        return true;
      },
      ...dialog.props
    }
    dialogObj.props = dialogProps;
    ReactDOM.render(dialogObj, document.getElementById(popup));
  };
};

Dialog.SaveCancel = (props) => {
  return (
    <Dialog {...props}>
      <div className='w2ui-centered'>
        {props.children}
      </div>
      <Dialog.SaveCancelButtons popup={props.popup} />
    </Dialog>

  );

}

export default Dialog;